import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import { Button, Tag } from "capitalrx-components-2.0/lib/general";
import { Body, Semibold, Subheading } from "capitalrx-components-2.0/lib/typography";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";

import { StackOrShelf } from "@/App/components/StackOrShelf";
import { SectionPanel } from "@/App/components";

import { ActivityTypes } from "./RecentActivity";

interface ActivityCardProps {
  activity: ActivityTypes;
}

const CLAIMS_PAGE_TRANSLATION_PATH = "DASHBOARD.recentActivityDashboard";

export const ActivityCard = ({ activity }: ActivityCardProps) => {
  const { t: translate } = useTranslation();
  const formattedActivityDate = DateTime.fromISO(activity.activity_date).toFormat("DDD");
  const isPriorAuthorizationType = Object.hasOwn(activity, "pa_case");

  return (
    <SectionPanel className="activity-card">
      <Stack>
        <Stack spacing="mini">
          <Shelf>
            <ActivityTypeTag activity={activity} />
            <Shelf.Spacer />
            <Body><Semibold>{formattedActivityDate}</Semibold></Body>
          </Shelf>
          <Stack spacing="none" >
            {
              Object.hasOwn(activity, "pa_case") && (
                <Body><Semibold>ID: </Semibold>{activity.pa_case.case_id}</Body>
              )
            }
            <Subheading>{activity.title}</Subheading>
          </Stack>
        </Stack>
        {activity.description}
        <StackOrShelf>
          {isPriorAuthorizationType && <Button appearance="text" onClick={activity.link}>{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.viewCase`)}</Button>}
          {!isPriorAuthorizationType && <Button appearance="text" onClick={activity.link}>{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.viewClaim`)}</Button>}
          <Shelf.Spacer />
        </StackOrShelf>
      </Stack>
    </SectionPanel>
  );
};


const ActivityTypeTag = ({ activity }: {activity: ActivityCardProps["activity"]}) => {
  const { t: translate } = useTranslation();

  if (Object.hasOwn(activity, "pa_case")) {
    return <Tag type="system-alternative">{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.priorAuthorization`)}</Tag>;
  } else if (Object.hasOwn(activity, "claim")) {
    return <Tag type="system">{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.pharmacyClaim`)}</Tag>;
  } else {
    switch (activity["medical_claim"].type) {
      case "vision":
        return <Tag type="info">{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.visionClaim`)}</Tag>;
      case "dental":
        return <Tag type="info">{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.dentalClaim`)}</Tag>;
      default:
        return <Tag type="success">{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.medicalClaim`)}</Tag>;
    }
  }
};
